import { render, staticRenderFns } from "./OnboardingUserNameForm.vue?vue&type=template&id=62d5abe5"
import script from "./OnboardingUserNameForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./OnboardingUserNameForm.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports